// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from '././components/Navigation.tsx';
import Dashboard from '././pages/Dashboard.tsx';
import NewDashboard from '././pages/Home.tsx';
import ProjectForm from '././components/ProjectForm.tsx';
import { mockUsers } from '././data/mockData.ts';
import { ProjectProvider } from '././context/ProjectContext.tsx';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from '././context/AuthContext.tsx';
import LoginPage from '././pages/LoginPage.tsx';
import { ProtectedRoute } from './components/ProtectedRoute.tsx';
import UsersPage from './pages/UsersPage.tsx';
import PergolaViewer from './components/visualization/PergolaViewer.tsx';
import { config } from './config/config.ts';

// Mock authentication - in a real app, this would come from your auth system
const currentUser = mockUsers[0]; // Using the admin user as default

const CreateProject = () => {
  if (!currentUser.permissions.includes('CREATE')) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Create New Project</h1>
      <ProjectForm currentUser={currentUser} />
    </div>
  );
};

const App: React.FC = () => {
  const { googleClientId } = config;

  // Ensure we have a client ID
  if (!googleClientId) {
    console.error('Google Client ID is not configured');
    return <div>Error: Google OAuth is not configured</div>;
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <AuthProvider>
        <ProjectProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <NewDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gray-50">
                      <Navigation currentPath="/" />
                      <Dashboard />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/create" element={
                <ProtectedRoute>
                  <div className="min-h-screen bg-gray-50">
                    <Navigation currentPath="/create" />
                    <CreateProject />
                  </div>
                </ProtectedRoute>
              } 
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gray-50">
                      <Navigation currentPath="/users" />
                      <UsersPage />
                    </div>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/projects/:id/visualization"
                element={
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gray-50">
                      <Navigation currentPath="/projects" />
                      <PergolaViewer fullScreen />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </ProjectProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;